// extracted by mini-css-extract-plugin
export var attachmentContainer = "_hs-0";
export var fileList = "_hs-2";
export var removeFileButton = "_hs-1";